'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log all errors to console for debugging
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-4">
      <h2 className="text-2xl font-semibold">Something went wrong!</h2>
      <p className="text-muted-foreground text-center max-w-md">
        {error.message || 'An unexpected error occurred'}
      </p>
      {error.digest && (
        <p className="text-sm text-muted-foreground">
          Error ID: {error.digest}
        </p>
      )}
      <Button
        onClick={() => {
          // Clear any localStorage/sessionStorage that might be causing issues
          if (typeof window !== 'undefined') {
            localStorage.clear();
            sessionStorage.clear();
          }
          reset();
        }}
      >
        Try again
      </Button>
    </div>
  );
} 